export default [
  // Movimentos de Caixa
  {
    path: 'tesouraria/movimentos-caixa/entrada-manual',
    name: 'tesouraria_movimentosCaixa_entradaManual',
    component: () => import(/* webpackChunkName: "EntradaManualCaixa" */ '@/views/modules/tesouraria/movimentosDeCaixa/EntradaManualCaixa'),
    meta: {
      middleware: [],
      title: 'modulo.tesouraria.movimentosCaixa.entradaManual',
      tab: true,
    },
  },
  {
    path: 'tesouraria/movimentos-caixa/movimentos-em-aberto',
    name: 'tesouraria_movimentosCaixa_movimentosEmAberto',
    component: () => import(/* webpackChunkName: "MovimentosEmAbertoCaixa" */ '@/views/modules/tesouraria/movimentosDeCaixa/MovimentosEmAbertoCaixa'),
    meta: {
      middleware: [],
      title: 'modulo.tesouraria.movimentosCaixa.movimentosEmAberto',
      tab: true,
    },
  },
  {
    path: 'tesouraria/movimentos-caixa/movimentos-em-aberto-test',
    name: 'tesouraria_movimentosCaixa_movimentosEmAbertoTest',
    component: () => import(/* webpackChunkName: "MovimentosEmAbertoCaixaTest" */ '@/views/modules/tesouraria/movimentosDeCaixa/MovimentosEmAbertoCaixaTest'),
    meta: {
      middleware: [],
      title: 'modules.movimentosCaixa.movimentosEmAbertoTest.label',
      tab: true,
    },
  },
  {
    path: 'tesouraria/movimentos-caixa/movimentos-em-aberto-excluidos',
    name: 'tesouraria_movimentosCaixa_movimentosEmAbertoExcluidos',
    component: () => import(/* webpackChunkName: "MovimentosEmAbertoExcluidosCaixa" */ '@/views/modules/tesouraria/movimentosDeCaixa/MovimentosEmAbertoExcluidosCaixa'),
    meta: {
      middleware: [],
      title: 'modulo.tesouraria.movimentosCaixa.movimentosEmAbertoExcluidos',
      tab: true,
    },
  },
  {
    path: 'tesouraria/movimentos-caixa/movimentos-efetivados',
    name: 'tesouraria_movimentosCaixa_movimentosEfetivados',
    component: () => import(/* webpackChunkName: "MovimentosEfetivadosCaixa" */ '@/views/modules/tesouraria/movimentosDeCaixa/MovimentosEfetivadosCaixa'),
    meta: {
      middleware: [],
      title: 'modulo.tesouraria.movimentosCaixa.movimentosEfetivados',
      tab: true,
    },
  },
  {
    path: 'tesouraria/movimentos-caixa/aprovacao',
    name: 'tesouraria_movimentosCaixa_caixaAprovacao',
    component: () => import(/* webpackChunkName: "CaixaDeAprovacao" */ '@/views/modules/tesouraria/movimentosDeCaixa/CaixaDeAprovacao'),
    meta: {
      middleware: [],
      title: 'modulo.tesouraria.movimentosCaixa.caixaAprovacao',
      tab: true,
    },
  },
  {
    path: 'tesouraria/movimentos-caixa/carga-de-movimentos',
    name: 'tesouraria_movimentosCaixa_cargaDeMovimentos',
    component: () => import(/* webpackChunkName: "CargaDeMovimentos" */ '@/views/modules/tesouraria/movimentosDeCaixa/CargaDeMovimentos'),
    meta: {
      middleware: [],
      title: 'modulo.tesouraria.movimentosCaixa.cargaDeMovimentos',
      tab: true,
    },
  },

  // Movimentos de Previsão
  {
    path: 'tesouraria/movimentos-previsao/entrada-manual',
    name: 'tesouraria_movimentosPrevisao_entradaManual',
    component: () => import(/* webpackChunkName: "EntradaManualPrevisao" */ '@/views/modules/tesouraria/movimentosDePrevisao/EntradaManualPrevisao'),
    meta: {
      middleware: [],
      title: 'modulo.tesouraria.movimentosPrevisao.entradaManual',
      tab: true,
    },
  },
  {
    path: 'tesouraria/movimentos-previsao/previsoes-em-aberto',
    name: 'tesouraria_movimentosPrevisao_previsoesEmAberto',
    component: () => import(/* webpackChunkName: "PrevisoesEmAberto" */ '@/views/modules/tesouraria/movimentosDePrevisao/PrevisoesEmAberto'),
    meta: {
      middleware: [],
      title: 'modulo.tesouraria.movimentosPrevisao.previsoesEmAberto',
      tab: true,
    },
  },
  {
    path: 'tesouraria/movimentos-previsao/previsoes-efetivadas',
    name: 'tesouraria_movimentosPrevisao_previsoesEfetivadas',
    component: () => import(/* webpackChunkName: "PrevisoesEfetivadas" */ '@/views/modules/tesouraria/movimentosDePrevisao/PrevisoesEfetivadas'),
    meta: {
      middleware: [],
      title: 'modulo.tesouraria.movimentosPrevisao.previsoesEfetivadas',
      tab: true,
    },
  },
  {
    path: 'tesouraria/movimentos-previsao/carga-de-movimentos',
    name: 'tesouraria_movimentosPrevisao_cargaDeMovimentos',
    component: () => import(/* webpackChunkName: "CargaDeMovimentosPrevisao" */ '@/views/modules/tesouraria/movimentosDePrevisao/CargaDeMovimentosPrevisao'),
    meta: {
      middleware: [],
      title: 'modulo.tesouraria.movimentosPrevisao.cargaDeMovimentos',
      tab: true,
    },
  },
  
  // Transferências
  {
    path: 'tesouraria/transferencias/grupos',
    name: 'tesouraria_transferencias_grupos',
    component: () => import(/* webpackChunkName: "grupos" */ '@/views/modules/tesouraria/Transferencias/grupos.vue'),
    meta: {
      middleware: [],
      title: 'modulo.transferencias.grupos',
      tab: true,
    },
  },

  //Fluxo de Caixa
  {
    path: 'treasury360',
    name: 'treasury360',
    component: () => import(/* webpackChunkName: "fluxoCaixa" */ '@/views/modules/tesouraria/fluxoCaixaV2/fluxoCaixa.vue'),
    meta: {
      middleware: [],
      title:  ('modulo.treasury360'),
      tab: true,
    },
  },

  {
    path: 'cenarios-gravados',
    name: 'cenariosGravados',
    component: () => import(/* webpackChunkName: "cenariosGravados" */ '@/views/modules/tesouraria/cenarios/cenariosGravados/index.vue'),
    meta: {
      middleware: [],
      title:  ('modulo.tesouraria.cenarios'),
      tab: true,
    },
  },

  {
    path: 'comparacao-cenarios',
    name: 'comparacaoCenarios',
    component: () => import(/* webpackChunkName: "comparacaoCenarios" */ '@/views/modules/tesouraria/cenarios/comparacaoCenarios/index.vue'),
    meta: {
      middleware: [],
      title:  ('modulo.tesouraria.comparacaoCenarios'),
      tab: true,
    },
  },

  {
    path: 'de-para',
    name: 'dePara',
    component: () => import(/* webpackChunkName: "dePara" */ '@/views/modules/tesouraria/dePara/index.vue'),
    meta: {
      middleware: [],
      title:  ('modulo.tesouraria.dePara'),
      tab: true,
    },
  },

];

